import dayjs from "dayjs";

/**
 * Returns the minimum expiry date possible,
 * given that the user needs to have a document with validity left (i.e.: 6 months).
 * @function
 * @name getMinExpiryDate
 * @kind function
 * @returns {dayjs.Dayjs} Neutral timezone date.
 * @exports
 */
export function getMinExpiryDate(): dayjs.Dayjs {
  const monthsOfValidity = 6;
  const today = new Date();
  const minDate = new Date(today.setMonth(today.getMonth() + monthsOfValidity));
  return dayjs(minDate);
}
